import { format } from 'date-fns';
import { api } from '@/services';

export default {
  async fetchRomaneios({
    dispatch,
    commit,
  }, filtros) {
    commit('SET_ROMANEIOS', []);
    dispatch('toggleLoading', true, { root: true });

    const {
      tipo, campoData, periodo, termo,
    } = filtros;
    const params = new URLSearchParams();
    params.append('tipo', tipo);

    if (campoData) {
      params.append('campoData', campoData);
    }
    if (periodo && periodo[0]) {
      const dataInicial = format(new Date(periodo[0]), 'yyyy-MM-dd');
      params.append('dataInicial', dataInicial);
    }
    if (periodo && periodo[1]) {
      const dataFinal = format(new Date(periodo[1]), 'yyyy-MM-dd');
      params.append('dataFinal', dataFinal);
    }
    if (termo) {
      params.append('termo', termo);
    }

    try {
      const response = await api.get('/romaneio', { params });
      commit('SET_ROMANEIOS', response.data);
    } catch (err) {
      dispatch('setGlobalError', 'Não foi possível recuperar os romaneios!', {
        root: true,
      });
    }
    dispatch('toggleLoading', false, { root: true });
  },
  async fetchRomaneio({
    commit,
    dispatch,
  }, idRegistro) {
    try {
      const romaneio = await api.get(`/romaneio/${idRegistro}`)
        .then((response) => response.data);
      commit('SET_ROMANEIO_SELECIONADO', romaneio);
    } catch (err) {
      dispatch('setGlobalError', 'Não foi possível recuperar os romaneios!', {
        root: true,
      });
    }
  },
};
